import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useState, useEffect } from "react";
import htmlToDraft from 'html-to-draftjs';

const BaseEditor = (props) => {
  const [rawData, setRawData] = useState(EditorState.createEmpty());
  const [data, setData] = useState();

  useEffect(() => {
    const contentBlocks = htmlToDraft(props.inialData);
    const contentState = ContentState.createFromBlockArray(contentBlocks);
    const _editorState = EditorState.createWithContent(contentState);
    setRawData(_editorState);
  }, [])

  const handleEditorChange = (state) => {
    setRawData(state);
    setData(convertToHTML(rawData.getCurrentContent()));

  }


  return (<Editor { ...props } editorState={ rawData } onEditorStateChange={ handleEditorChange } onChange={ props.onChange(data) } />);
}

export default BaseEditor;
